import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Permission } from '@rivethealth/data/user-account';

@Injectable()
export class PermissionsState {
  readonly permissions: Permission[] =
    this.route.snapshot.data['permissions'].permissions;
  readonly isRiveter: boolean =
    this.route.snapshot.data['permissions'].isRiveter;

  public isAllowed(permission: Permission) {
    return this.isRiveter
      ? true
      : this.permissions
        ? this.permissions.indexOf(permission) >= 0
        : false;
  }

  constructor(private readonly route: ActivatedRoute) {}
}
